import * as React from "react";
// import { Button } from "antd";
import ButtonGroup from "widget/buttonGroup";
import { EOrderListPageType } from "utils/enum/orderListFormEnum";

// 订单列表按钮组
interface IOrderListButtonGroupProps {
  pageType: EOrderListPageType;
  // 订单编号
  orderNo: any;
  // 查询列表
  onSearch: any;
  // 订单表单中的信息
  formParam: any;
  // 订单列表统计
  orderTotal: any;
}

let buttonGroup = props => {
  return [
    {
      label: "批量签名",
      type: 6,
      style: {
        width: 80
      },
      extField1: props.orderNo,
      extField2: props.onSearch
    },
    {
      label: "同步淘宝订单",
      type: 3,
      style: {
        width: 120
      },
      extField1: props.onSearch
    },
    {
      label: "新增订单",
      type: 11
    },
    {
      label: "二次确认",
      type: 4,
      extField1: props.orderNo,
      extField2: props.onSearch
    },
    {
      label: "批量发货",
      type: 5,
      style: {
        width: 80
      },
      extField1: props.orderNo,
      extField2: props.onSearch
    },
    {
      label: "批量售后",
      type: 8,
      style: {
        width: 80
      },
      extField1: props.orderNo,
      extField2: props.onSearch
    },
    {
      label: "导出Excel",
      type: 10,
      style: {
        width: 80
      },
      extField1: props.formParam
    },
    {
      label: "二次检查",
      type: 7,
      style: {
        width: 80
      },
      extField1: props.orderNo,
      extField2: props.onSearch
    },
    {
      label: "分配订单",
      type: 9,
      extField1: props.orderNo,
      extField2: props.onSearch
    },
    {
      label: "订单统计",
      type: 12,
      extField1: props.formParam,
      extField2: props.orderTotal
    }
  ];
};

// 设置需要显示的按钮
const setButtonField = (nextProps: any) => {
  const hiddenButton: Array<string> = getButtonShowField(
    nextProps.pageType,
    nextProps
  );
  const showButtonGroup = buttonGroup(nextProps).filter(item => {
    return hiddenButton.indexOf(item.label) != -1;
  });
  return showButtonGroup;
};

// 获取按钮组中需要隐藏的按钮
const getButtonShowField = (type, nextProps) => {
  let field = Array<string>();
  switch (Number(type)) {
    case EOrderListPageType.shangcheng:
      field = [
        "导出Excel",
        "批量签名",
        "新增订单",
        "分配订单",
        "批量售后",
        "二次检查"
      ];
      break;
    case EOrderListPageType.tianmaohaiwaidian:
    case EOrderListPageType.fengongsitianmaodian:
    case EOrderListPageType.tianmaolijiangdian:
    case EOrderListPageType.zidingdanliebiao:
    default:
      field = buttonGroup(nextProps).map(item => {
        return item.label;
      });
      break;
  }
  return field;
};

class OrderListButtonGroup extends React.Component<
  IOrderListButtonGroupProps,
  any
> {
  constructor(props: IOrderListButtonGroupProps) {
    super(props);

    this.state = {
      isRefresh: false,
      pageType: this.props.pageType,
      buttonGroup: setButtonField(this.props)
    };
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.pageType == prevState.pageType) {
      const showButtonGroup = setButtonField(nextProps);
      return {
        buttonGroup: showButtonGroup
      };
    } else {
      return {
        isRefresh: true,
        pageType: nextProps.pageType
      };
    }
  }

  shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any) {
    if (nextState.isRefresh) {
      const showButtonGroup = setButtonField(nextProps);
      this.setState({
        buttonGroup: showButtonGroup,
        isRefresh: false
      });
      return false;
    }
    return true;
  }

  render() {
    return (
      <React.Fragment>
        <ButtonGroup buttonGroup={this.state.buttonGroup} />
      </React.Fragment>
    );
  }
}

{
  /* <Button type="primary">批量签名</Button>
        <Button type="primary">同步淘宝订单</Button>
        <Button type="primary">新增订单</Button>
        <Button type="primary">二次确认</Button> */
}

export default OrderListButtonGroup;
